import { createAction, props } from '@ngrx/store';
import { SearchSystemLatestPage } from './search-system.model';

export const saveLatestPage = createAction(
  '[Search] Save Latest Page',
  props<{ latestPage: SearchSystemLatestPage }>()
);
